import { SITE } from '../config/site'

export default function BrandLogo({ className = '', imageClassName = 'h-9 w-9', showName = true, nameClassName = '' }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <img
        src="/brand/rawaj-logo.png"
        alt=""
        className={`${imageClassName} shrink-0 object-contain`}
        width="48"
        height="48"
      />
      {showName && <span className={nameClassName}>{SITE.name}</span>}
    </span>
  )
}
